var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{ref:"form",attrs:{"id":("formValidation-" + _vm._uid),"autocomplete":"off","novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_vm._t("default"),_vm._t("submit")],2)}
var staticRenderFns = []

export { render, staticRenderFns }